export const FORM_CONTROL_ID = 'comboBox-formControl';
export const VIEW_MODE_CONTAINER_ID = 'comboBox-viewMode-container';
export const LABEL_ID = 'comboBox-label';
export const COMBO_BOX_INPUT_ID = 'comboBox-input';

export const COMBO_BOX_LIST_ID = 'comboBox-list';
export const COMBO_BOX_LIST_ITEM_ID = 'comboBox-list-item';
export const COMBO_BOX_CHIP_ID = 'comboBox-chip';

export const ARIA_COMBO_BOX_LABEL = 'comboBox-label';
